export const isAppEnvironmentIos: boolean =
  /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  // @ts-expect-error
  !window.MSStream;
